"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderToJSON = exports.GenderFromJSONTyped = exports.GenderFromJSON = exports.Gender = void 0;
/**
 * The gender of the person
 * @export
 * @enum {string}
 */
var Gender;
(function (Gender) {
    Gender["M"] = "m";
    Gender["F"] = "f";
    Gender["D"] = "d";
})(Gender = exports.Gender || (exports.Gender = {}));
function GenderFromJSON(json) {
    return GenderFromJSONTyped(json, false);
}
exports.GenderFromJSON = GenderFromJSON;
function GenderFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GenderFromJSONTyped = GenderFromJSONTyped;
function GenderToJSON(value) {
    return value;
}
exports.GenderToJSON = GenderToJSON;
//# sourceMappingURL=Gender.js.map